$(document).on('preloadingComplete', function() {
  $('[protoflow-on-pageload-set]').each(function() {
      var key = $(this).find('[protoflow-on-pageload-set__key]').text().trim().split(' ').join('-');
      var valueToSet = $(this).find('[protoflow-on-pageload-set__value]').text().trim();

      if (isNotEmpty(key) && isNotEmpty(valueToSet)) {
        StateURL.set(key, valueToSet, {doNotCreateHistoryState: true});
      }
  });
});